module.exports = __webpack_public_path__ + "static/media/lg-ars-fab-cover.a646e14b.jpg";